import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { API_URL } from '../config';


const countries = [
  { name: 'India', code: 'IN' }, { name: 'United States', code: 'US' }, { name: 'United Kingdom', code: 'UK' },
  { name: 'Germany', code: 'DE' }, { name: 'Australia', code: 'AU' }, { name: 'Canada', code: 'CA' },
  { name: 'Brazil', code: 'BR' }, { name: 'South Africa', code: 'ZA' }, { name: 'Spain', code: 'ES' },
  { name: 'France', code: 'FR' }, { name: 'Italy', code: 'IT' }, { name: 'Japan', code: 'JP' },
  { name: 'Singapore', code: 'SG' }, { name: 'United Arab Emirates', code: 'AE' }, { name: 'Netherlands', code: 'NL' },
  { name: 'Switzerland', code: 'CH' }, { name: 'Sweden', code: 'SE' }, { name: 'Norway', code: 'NO' },
  { name: 'Denmark', code: 'DK' }, { name: 'Finland', code: 'FI' }, { name: 'New Zealand', code: 'NZ' },
  { name: 'Ireland', code: 'IE' }, { name: 'Mexico', code: 'MX' }, { name: 'Argentina', code: 'AR' },
  { name: 'Chile', code: 'CL' }, { name: 'Colombia', code: 'CO' }, { name: 'Peru', code: 'PE' },
  { name: 'Malaysia', code: 'MY' }, { name: 'Thailand', code: 'TH' }, { name: 'Indonesia', code: 'ID' },
  { name: 'Philippines', code: 'PH' }, { name: 'Vietnam', code: 'VN' }, { name: 'South Korea', code: 'KR' },
  { name: 'Taiwan', code: 'TW' }, { name: 'Hong Kong', code: 'HK' }, { name: 'Saudi Arabia', code: 'SA' },
  { name: 'Qatar', code: 'QA' }, { name: 'Israel', code: 'IL' }, { name: 'Turkey', code: 'TR' },
  { name: 'Egypt', code: 'EG' }, { name: 'Nigeria', code: 'NG' }, { name: 'Kenya', code: 'KE' },
  { name: 'Poland', code: 'PL' }, { name: 'Portugal', code: 'PT' }, { name: 'Greece', code: 'GR' }
];

const names = [
  'Aa***', 'Ab***', 'Ad***', 'Ag***', 'Ah***', 'Al***', 'Am***', 'An***', 'Ar***', 'As***',
  'Ba***', 'Be***', 'Bi***', 'Bl***', 'Bo***', 'Br***', 'Bu***', 'Ca***', 'Ce***', 'Ch***',
  'Cl***', 'Co***', 'Cr***', 'Cu***', 'Cy***', 'Da***', 'De***', 'Di***', 'Do***', 'Dr***',
  'Du***', 'Ed***', 'El***', 'Em***', 'En***', 'Er***', 'Es***', 'Et***', 'Ev***', 'Fa***',
  'Fe***', 'Fi***', 'Fl***', 'Fo***', 'Fr***', 'Fu***', 'Ga***', 'Ge***', 'Gi***', 'Gl***',
  'Go***', 'Gr***', 'Gu***', 'Ha***', 'He***', 'Hi***', 'Ho***', 'Hu***', 'Ia***', 'Ib***',
  'Id***', 'Ig***', 'Il***', 'Im***', 'In***', 'Ir***', 'Is***', 'Iv***', 'Ja***', 'Je***',
  'Ji***', 'Jo***', 'Ju***', 'Ka***', 'Ke***', 'Kh***', 'Ki***', 'Kl***', 'Ko***', 'Kr***',
  'Ku***', 'La***', 'Le***', 'Li***', 'Ll***', 'Lo***', 'Lu***', 'Ly***', 'Ma***', 'Me***',
  'Mi***', 'Mo***', 'Mu***', 'My***', 'Na***', 'Ne***', 'Ni***', 'No***', 'Nu***', 'Ny***',
  'Oa***', 'Ob***', 'Od***', 'Ol***', 'Om***', 'On***', 'Or***', 'Os***', 'Ot***', 'Ou***'
];

const RecentPurchasePopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [purchaseData, setPurchaseData] = useState(null);
  const [products, setProducts] = useState([]);

  // Fetch products to show real EA names
  useEffect(() => {
    fetch(`${API_URL}/api/products`)
      .then(res => res.json())
      .then(data => {
        if (Array.isArray(data)) {
          setProducts(data);
        } else {
          console.error('Failed to fetch products for popup: Not an array');
        }
      })
      .catch(err => console.error('Failed to fetch products for popup', err));
  }, []);

  useEffect(() => {
    if (!Array.isArray(products) || products.length === 0) return;

    const showRandomPopup = () => {
      // Generate random data
      const randomCountry = countries[Math.floor(Math.random() * countries.length)];
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomProduct = products[Math.floor(Math.random() * products.length)];
      if (!randomProduct) return;
      
      const randomTime = Math.floor(Math.random() * 59) + 1; // 1 to 59 mins ago

      setPurchaseData({
        country: randomCountry,
        name: randomName,
        productName: randomProduct.name,
        timeAgo: `${randomTime}m ago`
      });

      setIsVisible(true);

      // Hide after 5 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };

    // Initial popup after 3 seconds
    const initialTimeout = setTimeout(() => {
      showRandomPopup();
    }, 3000);

    // Then pop up randomly every 15 to 35 seconds
    const interval = setInterval(() => {
      showRandomPopup();
    }, Math.floor(Math.random() * 20000) + 15000);

    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, [products]);

  return (
    <AnimatePresence>
      {isVisible && purchaseData && (
        <motion.div
          initial={{ opacity: 0, y: 50, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 50, scale: 0.9 }}
          transition={{ type: 'spring', stiffness: 300, damping: 25 }}
          className="fixed bottom-6 left-6 z-[9999] bg-[#121212] border border-white/10 rounded-2xl p-4 shadow-2xl shadow-black/50 flex items-center gap-4 max-w-sm"
          style={{ backdropFilter: 'blur(10px)' }}
        >
          {/* Close button */}
          <button 
            onClick={() => setIsVisible(false)}
            className="absolute top-2 right-2 text-white/50 hover:text-white transition-colors"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
              <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
            </svg>
          </button>

          {/* Country Circle */}
          <div className="w-12 h-12 rounded-full border border-white/20 flex items-center justify-center bg-[#1a1a1a] text-white font-bold tracking-wider shrink-0">
            {purchaseData.country.code}
          </div>

          {/* Details */}
          <div className="flex flex-col">
            <div className="flex items-center gap-2 mb-1">
              <div className="w-2 h-2 rounded-full bg-[#00a86b] shadow-[0_0_8px_#00a86b]"></div>
              <span className="text-[#00a86b] text-[10px] font-bold tracking-widest uppercase">
                Recent Purchase
              </span>
            </div>
            <p className="text-sm text-gray-300 leading-snug pr-4">
              <span className="font-bold text-white">{purchaseData.name}</span> from {purchaseData.country.name} bought <span className="text-primary font-bold">{purchaseData.productName}</span>.
            </p>
            <p className="text-xs text-gray-500 mt-1">
              {purchaseData.timeAgo}
            </p>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default RecentPurchasePopup;
